import 'css-chunk:../../frontend/phi3d/src/js/components/Logo/index.module.scss';export default {
  "logo": "_logo_31fwz_1"
};